import cn from 'classnames';
import createHotKeyMap, { HotKey } from 'es/app/components/hot-keys/GlobalHotKeyMap';
import { RoutesOutlet } from 'es/app/components/layout/RoutesOutlet';
import { Suspense, useState } from 'react';
import { GlobalHotKeys } from 'react-hotkeys';
import Navbar from './nav/Navbar';
import NavDrawer from './nav/NavDrawer';
import UniversalSearch from './universal-search';
import styles from './Layout.module.css';
import Throbber from 'es/app/components/progress-indicators/Throbber';

import './Layout.scss';
import { BootstrapStyles } from 'es/app/visuals/styles/BootstrapStyles';

const KEY_MAP = createHotKeyMap(HotKey.UNIVERSAL_SEARCH, HotKey.CANCEL);

export const Layout = () => {
    const [showUniversalSearch, setShowUniversalSearch] = useState(false);
    const handleToggleUniversalSearch = () => setShowUniversalSearch(prev => !prev);
    const handleUniversalVisibilityChanged = (isVisible: boolean) => setShowUniversalSearch(isVisible);

    const hotKeyHandlers = {
        [HotKey.UNIVERSAL_SEARCH]: () => setShowUniversalSearch(prev => !prev),
        [HotKey.CANCEL]: () => setShowUniversalSearch(false),
    };

    return (
        <section className={styles.layout}>
            <NavDrawer />
            <div className={styles.mainContentWrapper}>
                <Navbar onToggleUniversalSearch={handleToggleUniversalSearch} />

                <div className={cn(styles.mainContent, BootstrapStyles['ps-2'])}>
                    <Suspense fallback={<Throbber text={'...'} />}>
                        <RoutesOutlet />
                    </Suspense>
                </div>
            </div>

            <UniversalSearch visible={showUniversalSearch} onVisibilityChanged={handleUniversalVisibilityChanged} />
            <GlobalHotKeys keyMap={KEY_MAP} handlers={hotKeyHandlers} />
        </section>
    );
};
